<div class="justup-dialog">
  <vl-header-dialog (close)="dialogRef.close()"></vl-header-dialog>
  <div class="pdf-loader" data-testid="pdf-loader">
    <div class="pdf-sheet" aria-hidden="true">
      <div class="pdf-header">
        <vl-just-logo width="32px" height="22px" color="var(--color-on-background)"/>
        <div class="pdf-header-rule"></div>
      </div>
      <div class="pdf-line"></div>
      <div class="pdf-line"></div>
      <div class="pdf-line short"></div>
      <div class="pdf-line"></div>
      <div class="pdf-line short"></div>
      <div class="pdf-badge">PDF</div>
      <div class="pdf-scan"></div>
    </div>
    <div class="pdf-label">
      <span class="body-2">{{ generating }}</span>
      <span class="dots"><span></span><span></span><span></span></span>
    </div>
  </div>
</div>
